"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.dropTableIfExists(_globals.MetaTable.SHARED_VIEWS);
    await knex.schema.dropTableIfExists(_globals.MetaTable.TEAM_USERS_OLD);
    await knex.schema.dropTableIfExists(_globals.MetaTable.TEAMS_OLD);
    await knex.schema.dropTableIfExists(_globals.MetaTable.ORGS_OLD);
    await knex.schema.dropTableIfExists('nc_shared_bases');
};
const down = async (knex)=>{
    await knex.schema.createTable(_globals.MetaTable.SHARED_VIEWS, (table)=>{
        table.string('id', 20).notNullable().primary();
        table.string('fk_view_id', 20);
        table.text('meta');
        table.text('query_params');
        table.string('view_id', 255);
        table.boolean('show_all_fields');
        table.boolean('allow_copy');
        table.string('password', 255);
        table.boolean('deleted');
        table.float('order');
        table.timestamp('created_at', {
            useTz: true
        }).defaultTo(knex.fn.now());
        table.timestamp('updated_at', {
            useTz: true
        }).defaultTo(knex.fn.now());
    });
    await knex.schema.createTable(_globals.MetaTable.TEAM_USERS_OLD, (table)=>{
        table.string('org_id', 20);
        table.string('user_id', 20);
        table.timestamps(true, true);
    // No explicit PK
    });
    await knex.schema.createTable(_globals.MetaTable.TEAMS_OLD, (table)=>{
        table.string('id', 20).notNullable().primary();
        table.string('title', 255);
        table.string('org_id', 20);
        table.timestamps(true, true);
    });
    await knex.schema.createTable(_globals.MetaTable.ORGS_OLD, (table)=>{
        table.string('id', 20).notNullable().primary();
        table.string('title', 255);
        table.timestamps(true, true);
    });
};
